export const defaultCities = {
  國立臺灣圖書館: true,
  臺北市立圖書館: true,
  新北市立圖書館: true,
  桃園市立圖書館: true,
  臺中市立圖書館: true,
  臺南市立圖書館: true,
  高雄市立圖書館: true,
  國家圖書館: true,
  基隆市文化局: false,
  新竹市圖書館: false,
  新竹縣政府文化局: false,
  苗栗市立圖書館: false,
  苗栗縣立圖書館: false,
  彰化雲端電子書庫: false,
  嘉義市政府文化局: false,
  花蓮縣文化局: false,
  臺東縣政府文化處: false,
  澎湖縣圖書館: false,
  金門縣文化局: false,
  連江縣公共圖書館: false,
};

const Status = Object.freeze({
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
});

export const hyreadCodeMapping = Object.freeze({
  國立臺灣圖書館: 276,
  臺北市立圖書館: 44,
  新北市立圖書館: 290,
  桃園市立圖書館: 342,
  臺中市立圖書館: 344,
  臺南市立圖書館: 138,
  高雄市立圖書館: 151,
  國家圖書館: 1,
  基隆市文化局: 609,
  新竹市圖書館: 341,
  新竹縣政府文化局: 497,
  苗栗市立圖書館: 654,
  苗栗縣立圖書館: 865,
  彰化雲端電子書庫: 763,
  嘉義市政府文化局: 399,
  花蓮縣文化局: 607,
  臺東縣政府文化處: 771,
  澎湖縣圖書館: 41,
  金門縣文化局: 63,
  連江縣公共圖書館: 48,
});

export const DISPLAY_RESULT_AMOUNT = 6;
export const HYREAD_BASE_URL =
  //'https://vercel-proxy-3ofk0hsly-michaels-projects-b607af2b.vercel.app';
  'https://vercel-proxy2-3z7j6byrn-boyyys-projects-5f298cf2.vercel.app';
export const HYREAD_BOOK_BASE_URL =
  'https://hyread-book-vercel-proxy-2d57mjz8w-aimees-projects-ec760c48.vercel.app';
export const HYREAD_SEARCH_BASE_URL =
  'https://hyread-search-vercel-proxy-dxs2a7gsn-edeys-projects-1772a484.vercel.app';
export const CLOUD_BASE_URL =
  'https://cloud-vercel-proxy-bfrx7dsxg-jasons-projects-4eddb4ba.vercel.app';
export const Iread_BASE_URL =
  'https://arti-vercel-proxy-p6n38iie6-michaels-projects-febc0595.vercel.app';
export const PUBLIC_INFO_BASE_URL =
  'https://public-info-vercel-proxy-b8zlo0jpg-eddies-projects-5657f937.vercel.app';
